import { render, staticRenderFns } from "./IndividualI.vue?vue&type=template&id=cc443c36"
import script from "./IndividualI.vue?vue&type=script&lang=js"
export * from "./IndividualI.vue?vue&type=script&lang=js"
import style0 from "./IndividualI.vue?vue&type=style&index=0&id=cc443c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports